module.exports = __webpack_public_path__ + "static/can-7cc6856aea3b7aee9a500a29fbed19ba.png";